export const abbreviateWallet = (wallet: string) => {
  const firstNine = wallet.slice(0, 8);
  const lastFour = wallet.slice(-4);
  return `${firstNine}...${lastFour}`;
};
